import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Divider,
} from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';

interface SupervisorConfigPanelProps {
  nodeId: string;
  nodeData: {
    label: string;
    instructions?: string;
  };
  onSave: (nodeId: string, data: any) => void;
  onClose: () => void;
}

const SupervisorConfigPanel: React.FC<SupervisorConfigPanelProps> = ({
  nodeId,
  nodeData,
  onSave,
  onClose,
}) => {
  const [name, setName] = useState(nodeData.label || '');
  const [instructions, setInstructions] = useState(nodeData.instructions || '');

  const handleSave = () => {
    const updatedData = {
      label: name,
      instructions,
    };
    onSave(nodeId, updatedData);
  };

  return (
    <Paper
      sx={{
        width: 400,
        height: '100vh',
        p: 3,
        borderRadius: 0,
        borderLeft: '1px solid #e0e0e0',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        position: 'fixed',
        top: 0,
        right: 0,
        zIndex: 1200,
      }}
    >
      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
          Configure Supervisor
        </Typography>
        <Button
          onClick={onClose}
          sx={{ minWidth: 'auto', p: 1 }}
        >
          <CloseIcon />
        </Button>
      </Box>

      <Divider sx={{ mb: 3 }} />

      {/* Configuration Form */}
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: 3, overflow: 'auto', pt: 1 }}>
        {/* Node Name */}
        <TextField
          label="Node Name"
          value={name}
          onChange={(e) => {
            if (e.target.value.length <= 30) {
              setName(e.target.value)
            }
          }}
          fullWidth
          variant="outlined"
          size="small"
        />

        {/* Instructions */}
        <TextField
          label="Instructions"
          value={instructions}
          onChange={(e) => setInstructions(e.target.value)}
          fullWidth
          multiline
          rows={6}
          variant="outlined"
          size="small"
          placeholder="Enter instructions for the supervisor..."
          required
        />
      </Box>

      {/* Save Button */}
      <Box sx={{ mt: 3, pt: 2, borderTop: '1px solid #e0e0e0' }}>
        <Button
          variant="contained"
          startIcon={<SaveIcon />}
          onClick={handleSave}
          fullWidth
          disabled={!name || !instructions.trim()}
        >
          Save Configuration
        </Button>
      </Box>
    </Paper>
  );
};

export default SupervisorConfigPanel;
